/* eslint-disable react/require-default-props */
import React from 'react';
import { inject } from 'mobx-react';
import Link from 'core/components/Link';
import { IReactComponent } from 'mobx-react/dist/types/IReactComponent';
import DeviceName from 'app/components/DeviceName';
import { hasId, LookupId } from 'app/util/lookups/createLookup';
import { useDeviceLookup, useDeviceLookupByName } from 'app/util/lookups/deviceIndex';

type DeviceLinkProps = {
  // TODO: improve typing for $app
  $app: {
    isSubtenant: boolean;
  };
  // authoritative when provided
  deviceId?: LookupId;
  // looked up only without a deviceId; otherwise shown while loading or when the device doesn't resolve
  name?: string;
  snmp_id?: string | number;
  // appends the device id to the resolved name
  showId?: boolean;
  children?: React.ReactNode;
};

// Links to a device (or its interface) once it resolves; avoids linking for subtenants (MKP)
const DeviceLink = ({ $app, deviceId, name, snmp_id, showId, children, ...rest }: DeviceLinkProps) => {
  const { data: deviceById } = useDeviceLookup(deviceId);
  const { data: deviceByName } = useDeviceLookupByName(hasId(deviceId) ? undefined : name);
  const linkName = (deviceById ?? deviceByName)?.device_name;
  const label = children ?? <DeviceName deviceId={deviceId} fallbackLabel={name} showId={showId} />;

  // loading, not found, not visible, or a subtenant (MKP)
  if (!linkName || $app.isSubtenant) {
    return <>{label}</>;
  }

  const path = `/v4/infrastructure/devices/${linkName}${snmp_id ? `/interfaces/${snmp_id}` : ''}`;
  return (
    <Link to={path} {...rest}>
      {label}
    </Link>
  );
};

export default inject('$app')(DeviceLink as unknown as IReactComponent);
